// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2NfHc","buttons":"Footer_buttons__G0ZNY"};